module.exports = __webpack_public_path__ + "img/sao-tome-and-principe.43f8786b.svg";